<div style="display:inline">
    <div *ngIf="showBack">
        <div class="float-left padding-0  margin-right-15 margin-left-5">
            <!-- <label class="font-12 font-bold label-vCenter"> Back </label> -->
            <button pTooltip="Back" class="mtab-secondary c-edit-btn border-rad-2" icon="fa fa-arrow-left" (click)="goBack()" pButton>
                <!-- <img class="sib-back-icon" src="assets/layout/images/backward.svg" title="Back to previous screen"> -->
            </button>
        </div>
    </div>
</div>